import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t) || t <= 0) return null;
  return {
    d: Math.floor(t / 86400000),
    h: Math.floor((t / 3600000) % 24),
    m: Math.floor((t / 60000) % 60),
    s: Math.floor((t / 1000) % 60),
  };
}

export function Countdown({ endsAt, className = "" }) {
  const [time, setTime] = useState(() => diff(endsAt));

  useEffect(() => {
    const id = setInterval(() => setTime(diff(endsAt)), 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (!endsAt || !time) return null;
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div
      data-testid="countdown-timer"
      className={`inline-flex items-center gap-2 bg-black/60 border border-jamaica-gold/40 px-3 py-1.5 text-jamaica-gold font-mono text-xs tracking-widest ${className}`}
    >
      <Clock className="w-3.5 h-3.5" />
      <span>{time.d}D</span>:<span>{pad(time.h)}</span>:<span>{pad(time.m)}</span>:<span>{pad(time.s)}</span>
    </div>
  );
}
